import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.ActionsRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about devices
 * using http requests.
*/
export default class ActionsRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.ActionsRestService#create
     * @methodOf rest.services.ActionsRestService
     * @function
     *
     * @description
     * Create an action
     *
     * @returns {Promise} The promise of the call.
     */
    create(payload) {

        return super.create(payload, 'actions/');

    }


    getAllAsync() {

        return super.getAllAsync('actions/');

    }

}

_serviceDependencies.push(ActionsRestService);

angular.module('rest.services')
    .service('ActionsRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/actionsRestService.js